module.exports = __webpack_public_path__ + "static/media/beneficios-casa.37117dea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/beneficios-casa.svg
// module id = 167
// module chunks = 0